module.exports = __webpack_public_path__ + "0a2130bc77714ca43368baf05326e290.pdf";